import { Component } from '@angular/core';

@Component({
  selector: 'app-diners-club-icon',
  templateUrl: './diners-club-icon.component.html',
  styleUrl: './diners-club-icon.component.scss'
})
export class DinersClubIconComponent {

}
